import { useMemo } from 'react';
import { StyleSheet } from 'react-native';

import { IconStarRateFill, Text, tokens } from '@fhs/ui';
import { HeaderFrame } from '@fhs/ui';
import { selectors, useAppSelector } from '@fhs-legacy/frontend/src/state/global-state';
import { IAppliedReward } from '@fhs-legacy/frontend/src/state/loyalty/hooks/types';
import { useLoyaltyUser } from '@fhs-legacy/frontend/src/state/loyalty/hooks/use-loyalty-user';
import { USER_POINTS_HEADER } from '@fhs-legacy/frontend/src/utils/test-ids';

export default function UserPointsDisplay() {
  const { loyaltyUser } = useLoyaltyUser();

  const appliedLoyaltyRewards = useAppSelector(selectors.loyalty.selectAppliedLoyaltyRewards);

  // Calculate total points deducted from applied rewards in the cart, maybe multiple rewards in future
  const totalPointsDeducted = useMemo<number>(() => {
    return (Object.values(appliedLoyaltyRewards) as IAppliedReward[]).reduce(
      (total: number, reward: IAppliedReward) => {
        return total + (reward.pointCost || 0) * (reward.timesApplied || 0);
      },
      0
    );
  }, [appliedLoyaltyRewards]);

  // Calculate displayed points (user points minus deducted points)
  const displayedPoints = useMemo(() => {
    if (!loyaltyUser?.points) return 0;
    const userPoints = Number(loyaltyUser.points) || 0;
    return Math.max(0, userPoints - totalPointsDeducted);
  }, [loyaltyUser?.points, totalPointsDeducted]);

  if (!!loyaltyUser?.points && displayedPoints >= 0) {
    return (
      <HeaderFrame.Right style={styles.loyaltyPoints}>
        <IconStarRateFill size={24} color={tokens.colors.$houseYellow} />
        <Text.Heading testID={USER_POINTS_HEADER} type="five">
          {displayedPoints.toLocaleString()}
        </Text.Heading>
      </HeaderFrame.Right>
    );
  } else {
    return null;
  }
}

const styles = StyleSheet.create({
  loyaltyPoints: {
    alignItems: 'center',
    gap: 4,
  },
});
